import React, { createContext, useContext } from 'react';
import { Modules, P125MyProfilePage as P125MyProfilePageType } from '~/lib/data-contract';

// Define the shape of the context
type ProfileContextType = {
    pageProps: P125MyProfilePageType;
    pageElements: Modules[];
    bottomPageElements: Modules[];
};

// Create the context with a default empty value
const ProfileContext = createContext<ProfileContextType | undefined>(undefined);

// Provider component
export const ProfileProvider: React.FC<{
    children: React.ReactNode;
    pageProps: P125MyProfilePageType;
}> = ({ children, pageProps }) => {
    const value = {
        pageProps,
        pageElements: pageProps.pageElements as Modules[],
        bottomPageElements: pageProps.bottomPageElements as Modules[],
    };

    return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
};

// Custom hook for using the context
export const useProfile = (): ProfileContextType => {
    const context = useContext(ProfileContext);
    if (context === undefined) {
        throw new Error('useProfile must be used within a ProfileProvider');
    }
    return context;
};
